import React from 'react';

const TaskDistributionSectionHeading = ({ title, description, count }) => (
  <div className="flex items-start justify-between gap-4">
    <div>
      <h2 className="text-lg font-semibold text-content">{title}</h2>
      <p className="mt-0.5 text-sm text-content-muted">{description}</p>
    </div>
    {count && (
      <span className="shrink-0 rounded-full border border-line bg-surface-2 px-2.5 py-1 text-[11px] font-semibold text-content">
        {count}
      </span>
    )}
  </div>
);

export default TaskDistributionSectionHeading;
